// store/modules/screenSize.js
import { debounce } from "lodash";

const state = {
  width: window.innerWidth,
  height: window.innerHeight,
};

const mutations = {
  SET_SCREEN_SIZE(state, { width, height }) {
    state.width = width;
    state.height = height;
  },
};

const actions = {
  updateScreenSize: debounce(({ commit }) => {
    commit("SET_SCREEN_SIZE", {
      width: window.innerWidth,
      height: window.innerHeight,
    });
  }, 150),
};

const getters = {
  screenWidth: (state) => state.width,
  screenHeight: (state) => state.height,
};

export default {
  state,
  mutations,
  actions,
  getters,
};
